export const faqConstants = {
    LOAD_REQUEST: 'FAQ_LOAD_REQUEST',
    LOAD_SUCCESS: 'FAQ_LOAD_SUCCESS',
    LOAD_FAILURE: 'FAQ_LOAD_FAILURE',

    SEARCH_REQUEST: 'FAQ_SEARCH_REQUEST',
    SEARCH_SUCCESS: 'FAQ_SEARCH_SUCCESS',
    SEARCH_FAILURE: 'FAQ_SEARCH_FAILURE',

    SELECT_REQUEST: 'FAQ_SELECT_REQUEST',

    // DETAILS_REQUEST: 'FAQ_DETAILS_REQUEST',
    // DETAILS_SUCCESS: 'FAQ_DETAILS_SUCCESS',
    // DETAILS_FAILURE: 'FAQ_DETAILS_FAILURE',
}
